import { usePresenceStatus } from "@/contexts/PresenceContext";
import { cn } from "@/lib/utils";

interface Props {
  userId: string | null | undefined;
  /** Størrelse: sm = 8px, md = 10px, lg = 12px */
  size?: "sm" | "md" | "lg";
  /** Vis grå dot også for offline. Default: true (skjult når offline) */
  hideOffline?: boolean;
  className?: string;
}

const SIZE_CLASSES = {
  sm: "w-2 h-2",
  md: "w-2.5 h-2.5",
  lg: "w-3 h-3",
};

const STATUS_CLASSES = {
  online: "bg-emerald-500",
  idle: "bg-amber-500",
  offline: "bg-muted-foreground/40",
};

/**
 * Liten farget dot som viser presence-status for en bruker.
 * Default: skjult når offline. Plasseres ofte absolutt over hjørnet av
 * en avatar — parent trenger `relative`-positioning.
 */
export function PresenceDot({
  userId,
  size = "md",
  hideOffline = true,
  className,
}: Props) {
  const status = usePresenceStatus(userId);
  if (status === "offline" && hideOffline) return null;
  return (
    <span
      aria-label={
        status === "online"
          ? "Pålogget"
          : status === "idle"
            ? "Inaktiv"
            : "Offline"
      }
      className={cn(
        "rounded-full ring-2 ring-background",
        SIZE_CLASSES[size],
        STATUS_CLASSES[status],
        className,
      )}
    />
  );
}
